export function closestMultipleOf(number: number|string, step: number|string) {
  number = Number(number);
  step = Number(step);

  // Check if the number is already a multiple of a step
  if (number % step === 0) {
    return number;
  }

  // Calculate the closest multiple by rounding up
  return Math.ceil(number / step) * step;
}
